<template>
  <svg id="Iconen" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50.05 50.05" style="fill:none;stroke:black;stroke-miterlimit:10">
    <path class="cls-1" d="M16,30.97h15.87c3.59.08,6.12,3.3,5.53,6.69-.44,2.48-2.8,4.13-5.28,3.69-1.98-.35-3.3-2.24-2.95-4.22.28-1.59,1.79-2.64,3.38-2.36,1.27.22,2.11,1.44,1.89,2.7"/>
    <path class="cls-1" d="M10.72,27.69h27.05c3.59-.08,6.12-3.3,5.53-6.69-.44-2.48-2.8-4.13-5.28-3.69-1.98.35-3.3,2.24-2.95,4.22.28,1.59,1.79,2.64,3.38,2.36,1.27-.22,2.11-1.44,1.89-2.7"/>
    <path class="cls-1" d="M6.49,24.37h20.26c3.59-.08,6.12-3.3,5.53-6.69-.44-2.48-2.8-4.13-5.28-3.69-1.98.35-3.3,2.24-2.95,4.22.28,1.59,1.79,2.64,3.38,2.36,1.27-.22,2.11-1.44,1.89-2.7"/>
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconVentilatie extends Vue {}
</script>

<style scoped type="text/css">
.st0 {
  fill: none;
  stroke: #1d1d1b;
  stroke-miterlimit: 10;
}

.st1 {
  fill: none;
  stroke: #1d1d1b;
  stroke-linecap: round;
}

.st2 {
  fill: #1d1d1b;
}

.st3 {
  display: none;
}

.st4 {
  display: inline;
}

.st5 {
  fill: none;
  stroke: #29abe2;
  stroke-miterlimit: 10;
}
</style>
